// Partners can set their own validity window; rows logged before the API
// recorded it (CRM-1708) were all expired on the default one.
const DEFAULT_EXPIRATION_DAYS = 30;

export const describeIdentityVerificationExpiry = (metadata?: {
  expired_by?: "time_limit" | "partner_api";
  expiration_days?: number;
}): string => {
  if (metadata?.expired_by === "partner_api")
    return "Expired by a request through the Boom API";

  const days = metadata?.expiration_days ?? DEFAULT_EXPIRATION_DAYS;
  return `Identity verification results are only valid for ${days} ${days === 1 ? "day" : "days"}`;
};
